module.exports = __webpack_public_path__ + "img/people.483b9f74.png";